// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__378LS","tab":"Tabs_tab__3lG1R","tabActive":"Tabs_tabActive__136pC"};